/*
* Modal
*/
var $modal = $('#alert-modal');

// $.ajax('foo/alert-modal')
// .done(function(resp){
//     // $modal.html(resp).foundation('open');
//     $modal.html(resp);
// });

$(document).ready(function(){
    $('.alert-modal-link').click(function(){
        // $modal.load('foo/alert-modal', function() {
        //     $modal.foundation('open');
        //   });
        // $modal.load('foo/alert-modal');
        // $modal.foundation('open');
        $("#alert-modal").load(base_url + '/' + lang_url+ '/foo/alert-modal').foundation('open');
        // $.ajax('foo/alert-modal')
        // .done(function(resp){
        //     // $modal.html(resp).foundation('open');
        //     $modal.html(resp);
        //     $modal.foundation('open');
        // });
    });
    
});


/*
 * Progress Bar
 */
$(document).ready(function(){
  var position = 0,
    windowHeight = $(window).height(),
    documentHeight = $(document).height(),
    footerHeight = $("footer").height(),
    progressBarExists = $('.BodyLayout-mainContent').length > 0,
    progressBar = $('.ribbon > span');

  function updateProgressBar() {
    var progressBar = $('.ribbon > span'),
      progressBarPercent = position * 100 / (footerHeight + $('.BodyLayout-mainContent').position().top + $('.BodyLayout-mainContent').height() - windowHeight);
    progressBar.css({'width': progressBarPercent + '%'});
    //console.log((footerHeight + $('.BodyLayout-mainContent').position().top + $('.BodyLayout-mainContent').height() - windowHeight));
  };

  $(window).scroll(function(){
    position = $(window).scrollTop();

    if(progressBarExists) {
      updateProgressBar();
    }

  });
});

/*
 * Topbar menu bold
 */
//$(".WideMenu > li > a").delay(1000).animate({ opacity: 1 }, 700);
// $(".WideMenu ul > li > a").html(function(i,html){
//     return html.replace(/^\s*([^\s]+)(\s|$)/, '<span>$1 </span>');
// });

// $(".WideMenu").css('visibility', 'visible');
//
// jQuery(function($) {
//     $(".WideMenu ul > li > a").attr('href', "javascript:void(0)");
// });



window.onscroll = function() { myFunction() };
var navbar = document.querySelector('.SiteHeader');

function myFunction() {
    setInterval(function() {
        if (window.pageYOffset > 0) {
            navbar.classList.remove("stetch");
        } else {
            navbar.classList.add("stetch")
        }
    }, 250);
}

/////////////////////////////////////////////
/////////////Scroll Magic////////////////////
///////////////////////////////////////////
// document.addEventListener("DOMContentLoaded", function() {
  gsap.registerPlugin(ScrollTrigger);
  const showAnim = gsap.from('.SiteHeader', { 
    yPercent: -100,
    paused: true,
    duration: 0.2
  }).progress(1);
  
  ScrollTrigger.create({
    start: "top top",
    end: "+=500",
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse()
    }
  });
// })
// $(function() {

//     // // Init ScrollMagic scrollMagicSiteHeaderController
//     var scrollMagicSiteHeaderController = new ScrollMagic.Controller();


//     // new ScrollMagic.Scene({triggerElement: ".SiteHeader", triggerHook: "onLeave"})
//     //     .setClassToggle('.SiteHeader', 'SiteHeader-fixed')
//     //     .addTo(scrollMagicSiteHeaderController);

//     if ($('#body.fixed.invert').length) {
//         var i1 = 0;
//         var i2 = 0;
//         new ScrollMagic.Scene()
//             .addTo(scrollMagicSiteHeaderController)
//             .on("update", function () {
//                 var x1 = scrollMagicSiteHeaderController.info("scrollDirection");
//                 var x2 = $(window).scrollTop() + 1;
//                 var x3 = 400;
//                 if (x1 == "REVERSE" && x2 >= x3 && i1 == 0) {
//                     TweenMax.fromTo(".SiteHeader", 0.3, {
//                         top: "-210px",
//                         background: "rgba(0,0,0,0)",
//                         color: "white"
//                     }, {top: "0px", backgroundColor: "rgba(255,255,255,.85)", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader a, .SiteHeader i, .SiteHeader svg, .SiteHeader .weather, .SiteHeader button", 0.3, {color: "#333", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .TitleBar a", 0.3, {textShadow: "none", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .QuickAccess a", 0.3, {color: "#666", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu", 0, {display: "none", ease: Linear.easeNone});
//                     i1++;
//                     i2 = 0;
//                 }
//                 if (x1 == "FORWARD" && x2 > x3 && i2 == 0) {
//                     TweenMax.fromTo(".SiteHeader", 0.3, {top: "0px", background: "rgba(0,0,0,0)"}, {
//                         top: "-210px",
//                         backgroundColor: "rgba(0,0,0,0)",
//                         ease: Linear.easeNone
//                     });
//                     i1 = 0;
//                     i2++;
//                 }
//                 if (x2 < x3 && i2 == 0) {
//                     // TweenMax.to(".SiteHeader", 0.3, {background: "linear-gradient(to top, rgba(0,0,0,0) 0%, rgba(0,0,0,.1) 100%)", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader", 0.3, {background: "transparent", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader a, .SiteHeader i, .SiteHeader svg, .SiteHeader .weather, .SiteHeader button", 0.3, {color: "white", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .TitleBar a", 0.3, {textShadow: "0 1px 3px rgba(0, 0, 0, 0.8)", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .QuickAccess a", 0.3, {color: "#D7D5CE", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu", 0, {display: "flex", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu .is-dropdown-submenu a", 0, {color: "#fff", ease: Linear.easeNone});
//                     i1++;
//                     i2 = 0;
//                 }
//             });
//     }

//     if ($('#body:not(.fixed,.invert)').length) {
//         var i1 = 0;
//         var i2 = 0;
//         new ScrollMagic.Scene()
//             .addTo(scrollMagicSiteHeaderController)
//             .on("update", function () {
//                 var x1 = scrollMagicSiteHeaderController.info("scrollDirection");
//                 var x2 = $(window).scrollTop() + 1;
//                 var x3 = 10;
//                 if (x1 == "REVERSE" && x2 >= x3 && i1 == 0) {
//                     TweenMax.fromTo(".SiteHeader", 0.3, {
//                         position: "fixed",
//                         top: "-210px",
//                         backgroundColor: "rgba(0,0,0,0)"
//                     }, {top: "0px", backgroundColor: "rgba(255,255,255,.85)", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader a, .SiteHeader i, .SiteHeader svg, .SiteHeader .weather, .SiteHeader button", 0.3, {color: "#333", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu", 0, {display: "none", ease: Linear.easeNone});
//                     i1++;
//                     i2 = 0;
//                 }
//                 if (x1 == "FORWARD" && x2 > x3 && i2 == 0) {
//                     TweenMax.fromTo(".SiteHeader", 0.3, {top: "0px", backgroundColor: "rgba(0,0,0,0)"}, {
//                         position: "relative",
//                         top: "-210px",
//                         backgroundColor: "rgba(0,0,0,0)",
//                         ease: Linear.easeNone
//                     });
//                     i1 = 0;
//                     i2++;
//                 }
//                 if (x2 < x3 && i2 == 0) {
//                     TweenMax.to(".SiteHeader", 0.3, {position: "relative", backgroundColor: "rgba(0,0,0,0)", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu", 0, {display: "flex", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu .is-dropdown-submenu a", 0, {color: "#fff", ease: Linear.easeNone});
//                     i1++;
//                     i2 = 0;
//                 }
//             });
//     }

//     if ($('.fixed:not(.invert)').length) {
//         var i1 = 0;
//         var i2 = 0;
//         new ScrollMagic.Scene()
//             .addTo(scrollMagicSiteHeaderController)
//             .on("update", function () {
//                 var x1 = scrollMagicSiteHeaderController.info("scrollDirection");
//                 var x2 = $(window).scrollTop() + 1;
//                 var x3 = 10;
//                 if (x1 == "REVERSE" && x2 >= x3 && i1 == 0) {
//                     TweenMax.fromTo(".SiteHeader", 0.3, {
//                         top: "-210px",
//                         backgroundColor: "rgba(0,0,0,0)"
//                     }, {top: "0px", backgroundColor: "rgba(255,255,255,.85)", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader a, .SiteHeader i, .SiteHeader svg, .SiteHeader .weather, .SiteHeader button", 0.3, {color: "#333", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu", 0, {display: "none", ease: Linear.easeNone});
//                     i1++;
//                     i2 = 0;
//                 }
//                 if (x1 == "FORWARD" && x2 > x3 && i2 == 0) {
//                     TweenMax.fromTo(".SiteHeader", 0.3, {top: "0px", backgroundColor: "rgba(0,0,0,0)"}, {
//                         top: "-210px",
//                         backgroundColor: "rgba(0,0,0,0)",
//                         ease: Linear.easeNone
//                     });
//                     i1 = 0;
//                     i2++;
//                 }
//                 if (x2 < x3 && i2 == 0) {
//                     TweenMax.to(".SiteHeader", 0.3, {backgroundColor: "rgba(0,0,0,0)", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu", 0, {display: "flex", ease: Linear.easeNone});
//                     TweenMax.to(".SiteHeader .WideMenu .is-dropdown-submenu a", 0, {color: "#fff", ease: Linear.easeNone});
//                     i1++;
//                     i2 = 0;
//                 }
//             });
//     }
// });
